import { Component, OnInit } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { UrlConstants } from '../../../../shared/url.constant';
import {CommonUtil} from '../../../../utils/common.util';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.scss']
})
export class AdminSidebarComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  public userName = '';

  public pendingCount = '0';
  isCurrentYear: boolean = false;

  constructor(private router: Router) {
    if (localStorage.getItem('pendingCount')) {
      this.pendingCount = localStorage.getItem('pendingCount');
    }
  }

  ngOnInit() {
    const token = localStorage.getItem('userToken');
    if (token !== null) {
      const userData = jwt_decode(token);
      this.userName = userData.name;
    }
    if (UrlConstants.ACADEMIC_YEAR == "current") {
      this.isCurrentYear = true;
    }
    else {
      this.isCurrentYear = false;
      if (this.router.routerState.snapshot.url == '/admin/school-management/transferList' || this.router.routerState.snapshot.url == '/admin/school-management/transferStudents') {
        this.router.navigateByUrl('/admin/dashboard')
      }
    }
    // active class remove class
    (<any>$('.side-menu-root > a').click(function() {
      (<any>$('.side-menu-root.active')).removeClass('active');
      (<any>$(this).closest('li')).addClass('active');
    }));
  }

}
